import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  WritableSignal,
  inject,
  signal,
} from '@angular/core';
import { CreditAccount, UserContainer } from '@enrollhere/classes';
import { CARRY_FORWARD_ACCOUNT_ID } from '../../../data/constants';
import { PermanentTagCardComponent } from '../../ui-components/permanent-tags/permanent-tag-card/permanent-tag-card.component';
import { CreditAccountService } from '../../../services/credit-account.service';
import { AuthService } from '../../../services/auth.service';
import { firstValueFrom } from 'rxjs';
import { UserCardComponent } from '../../ui-components/user-card/user-card.component';
import { AsyncPipe } from '@angular/common';
@Component({
  selector: 'app-account-card',
  standalone: true,
  imports: [AsyncPipe, PermanentTagCardComponent, UserCardComponent],
  templateUrl: './account-card.component.html',
  styleUrl: './account-card.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AccountCardComponent implements OnInit {
  private authService = inject(AuthService);
  private creditAccountService = inject(CreditAccountService);

  @Input() owner?: UserContainer;
  @Input() accountId?: string;

  @Input() type: 'text' | 'card' = 'text';

  account: WritableSignal<CreditAccount | null> = signal(null);
  accountUnavailable = signal(false);
  CARRY_FORWARD_ACCOUNT_ID = CARRY_FORWARD_ACCOUNT_ID;

  currentUser$ = this.authService.currentUser$;

  async ngOnInit(): Promise<void> {
    if (!this.owner?.id) {
      const currentUser = await firstValueFrom(this.authService.currentUser$);
      if (currentUser) {
        this.owner = {
          id: currentUser.id,
          type: currentUser.userType,
        };
      }
    }

    if (
      this.accountId &&
      this.accountId !== CARRY_FORWARD_ACCOUNT_ID &&
      this.owner?.id
    ) {
      this.creditAccountService
        .getAccount(
          {
            id: this.accountId,
            owner: {
              id: this.owner.id,
              type: this.owner.type,
            },
          },
          true,
          // The card renders "Account unavailable" itself; a toast per row spams the table.
          true
        )
        .subscribe(account => {
          this.account.set(account?.data ?? null);
          this.accountUnavailable.set(!account?.data);
        });
    }
  }
}
